<template>
  <a-card :bordered="false">
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
    </a-table>
  </a-card>
</template>

<script>
import { tableListMixin } from "@/mixins";
import { projectExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "项目名称", dataIndex: "projectName", key: "projectName" },
  { title: '开始时间', dataIndex: "startTime", key: "startTime" },
  { title: '结束时间', dataIndex: "endTime", key: "endTime" },
  { title: '职位', dataIndex: "jobTitle", key: "jobTitle" },
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: {
  },
  data() {
    return {
      dateFormat,
      columns,
      queryParam: {},
      listUrl: projectExpriseInfo.pageList,
      listKeyField: "id",
    }
  },
}
</script>

<style scoped></style>
